import {
  TypographyVariants,
  Typography
} from "@certa/catalyst/components/Typography";
import { Box } from "@certa/catalyst/layouts/Box";
import { Tooltip } from "@certa/catalyst/components/Tooltip";
import { Stack } from "@certa/catalyst/layouts/Stack";

import type { CatalystColors } from "@certa/catalyst/constants/styles";
import type { DataObjectFieldRAGRuleRaw } from "@certa/types/src/dataObjects.types";

import { getRAGIndicator } from "../../../utils/dataObject/overview";
import { useIntl } from "react-intl";

type DataObjectTableFieldRAGCellProps = {
  rag: DataObjectFieldRAGRuleRaw;
  translatedRag?: DataObjectFieldRAGRuleRaw;
  formattedFieldValue: string | number | null;
  fieldValue: string | number | null;
};

export const DataObjectTableFieldRAGCell = (
  props: DataObjectTableFieldRAGCellProps
) => {
  const { rag, translatedRag, formattedFieldValue, fieldValue } = props;

  const intl = useIntl();

  const ragData =
    rag && fieldValue !== null ? getRAGIndicator(rag, fieldValue, intl) : null;

  const translatedRagData =
    translatedRag && fieldValue !== null
      ? getRAGIndicator(translatedRag, fieldValue, intl)
      : null;

  if (!ragData) return null;

  const { color, backgroundColor } = ragData;
  const { label, description } = translatedRagData || ragData;

  return (
    <Tooltip
      showArrow={true}
      show={!!description}
      content={
        <Stack gap="8">
          <Box>{label}</Box>
          <Box>{description}</Box>
        </Stack>
      }
      maxWidth="20rem"
    >
      <Box
        backgroundColor={backgroundColor as CatalystColors}
        padding="8"
        borderRadius="4"
        width="fit-content"
      >
        <Typography
          style={{
            whiteSpace: "nowrap"
          }}
          color={color as CatalystColors}
          variant={TypographyVariants.OVERLINE_SMALL}
        >
          {formattedFieldValue === 0 ? "0" : formattedFieldValue || "-"}
        </Typography>
      </Box>
    </Tooltip>
  );
};
